import axios from "axios";
import {INVOICE_LIST_URL} from '../../config/links.js'
import {toast} from 'react-toastify'

export const FETCH_TRIPL_INVOICE_LIST = 'FETCH_TRIPL_INVOICE_LIST'
export const RECEIVE_TRIPL_INVOICE_LIST = 'RECEIVE_TRIPL_INVOICE_LIST'
export const FAILED_TRIPL_INVOICE_LIST = 'FAILED_TRIPL_INVOICE_LIST'

export function fetchTriPlInvoices(_idCompany){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_TRIPL_INVOICE_LIST});
        axios({
            method: 'post',
            url: INVOICE_LIST_URL,
            headers: {
                Authorization: auth
            },
            data: {
                id_company: _idCompany
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_TRIPL_INVOICE_LIST,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_TRIPL_INVOICE_LIST
                    })
                    return toast.error('Unathorized access!');
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_TRIPL_INVOICE_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_TRIPL_INVOICE_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_TRIPL_INVOICE_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_TRIPL_INVOICE_LIST
                })
                return toast.error("Something went wrong!... Please try again later.");
            } else {
                dispatch({
                    type: FAILED_TRIPL_INVOICE_LIST
                })
                return toast.error("Something went wrong!... Please try again later.");
            }

        })
    }
}